import { useCallback } from 'react'

import { observeHeightAvailable, unobserveHeightAvailable } from '@/utils/observerUtil'

export const useHeightAvailable = () =>
  useCallback((el: HTMLElement | null) => {
    if (!el) return

    observeHeightAvailable(el)

    return () => unobserveHeightAvailable(el)
  }, [])
